import type {
  AppointmentProjection,
  CheckoutProjection,
  ClientProjection,
  DashboardProjection,
  SalonSettings,
  ServiceProjection,
  ShowcaseInfo,
  StaffProjection,
  StyleProjection
  ,WaitingEntryProjection
  ,ClientDetailsProjection, StyleCategoryProjection, StyleCatalogSettings, CustomerStylePreview, CheckoutDraftProjection, CheckoutDetailProjection, DailyFinanceSummary, CashSessionProjection, FinancePaymentMethod, OperationsDashboardProjection, ConsumptionPreviewProjection, BusinessDayClosingProjection, LoyaltyPolicy, LoyaltyProfileProjection, LoyaltyMovementProjection, CheckoutLoyaltyPreview, CommissionPolicy, GrowthAnalyticsProjection, StockItemView, SupplierProjection, PurchaseReceiptProjection, ServiceConsumableRecipeProjection, InventoryPolicy, InventoryReportProjection, InventoryMovementProjection, ExpenseProjection, PayableView, SupplierAccountProjection, DayCashSummary, BusinessDayRecord, StaffShiftView, StaffBoardRow, TaskProjection, BusinessSettings, BusinessOverview, BusinessReport, SystemStatusSummary, EmployeeRow, EmployeeDetailProjection, LeaveRecordProjection, WorkforceCalendarProjection, SalaryPreviewProjection, WorkforceOverview
} from '../application/contracts.js';

export type ViewKey = 'dashboard' | 'appointments' | 'clients' | 'catalog' | 'inventory' | 'employees' | 'checkout' | 'business' | 'operations' | 'reports' | 'settings';
export type SettingsTab = 'general' | 'appointments' | 'catalog' | 'growth' | 'inventory' | 'business' | 'backup' | 'showcase';

export interface AppData {
  info: ShowcaseInfo;
  dashboard: DashboardProjection;
  appointments: AppointmentProjection[];
  staff: StaffProjection[];
  clients: ClientProjection[];
  services: ServiceProjection[];
  styles: StyleProjection[];
  checkout: CheckoutProjection[];
  settings: SalonSettings;
  waitingList: WaitingEntryProjection[];
  clientDetails: ClientDetailsProjection | null;
  styleCategories: StyleCategoryProjection[];
  styleCatalogSettings: StyleCatalogSettings;
  customerPreview: CustomerStylePreview;
  checkoutHistory: CheckoutDraftProjection[];
  checkoutDetail: CheckoutDetailProjection | null;
  financeSummary: DailyFinanceSummary;
  cashSession: CashSessionProjection;
  checkoutPaymentMethods: Record<string,FinancePaymentMethod[]>;
  operations: OperationsDashboardProjection;
  consumptionPreview: ConsumptionPreviewProjection | null;
  closingSummary: BusinessDayClosingProjection | null;
  loyaltyPolicy: LoyaltyPolicy;
  commissionPolicy: CommissionPolicy;
  growth: GrowthAnalyticsProjection;
  clientLoyalty: LoyaltyProfileProjection | null;
  clientLoyaltyMovements: LoyaltyMovementProjection[];
  checkoutLoyalty: CheckoutLoyaltyPreview | null;
  stockItems: StockItemView[];
  suppliers: SupplierProjection[];
  purchases: PurchaseReceiptProjection[];
  recipes: ServiceConsumableRecipeProjection[];
  inventoryPolicy: InventoryPolicy;
  inventoryReport: InventoryReportProjection;
  expenses: ExpenseProjection[];
  payables: PayableView[];
  supplierAccount: SupplierAccountProjection | null;
  dayCash: DayCashSummary;
  businessDayHistory: BusinessDayRecord[];
  shifts: StaffShiftView[];
  staffBoard: StaffBoardRow[];
  tasks: TaskProjection[];
  businessSettings: BusinessSettings;
  businessOverview: BusinessOverview;
  businessReport: BusinessReport;
  systemStatus: SystemStatusSummary;
  employees: EmployeeRow[];
  employeeDetail: EmployeeDetailProjection | null;
  leaves: LeaveRecordProjection[];
  workforceCalendar: WorkforceCalendarProjection;
  salaryPreview: SalaryPreviewProjection;
  workforceOverview: WorkforceOverview;
}

export type CalendarView = 'day' | 'week' | 'month';
export type AppointmentModal = { kind: 'create' | 'edit' | 'walkin'; appointmentId?: string; startAt?: string; staffId?: string; clientId?: string };

export interface UiState {
  view: ViewKey;
  settingsTab: SettingsTab;
  clientQuery: string;
  clientTag: string;
  selectedClientId: string | null;
  calendarView: CalendarView;
  selectedDate: string;
  staffFilter: string;
  appointmentModal: AppointmentModal | null;
  clientStylist: string;
  clientUpcoming: boolean;
  clientRecent: boolean;
  clientTab: 'overview'|'loyalty'|'profile'|'visits'|'color'|'media';
  styleQuery: string;
  styleCategory: string;
  styleModal: 'create'|'category'|'preview'|null;
  selectedStyleId: string|null;
  selectedCategoryId: string|null;
  previewClientId: string;
  previewCategoryId: string;
  previewFavoritesOnly: boolean;
  selectedCheckoutId: string|null;
  checkoutStatus: string;
  checkoutPaymentMethod: string;
  receiptOpen: boolean;
  operationsDrawer: boolean;
  selectedAppointmentId: string | null;
  inventoryTab: 'items'|'purchases'|'suppliers'|'recipes';
  stockQuery: string; stockCategory: string; stockType: string; stockStatus: string; stockShowPassive: boolean;
  selectedStockItemId: string | null; selectedSupplierId: string | null; selectedRecipeServiceId: string | null;
  stockDrawer: 'detail'|'create'|'edit'|'purchase'|'adjust'|'waste'|'count'|'supplier'|'recipe'|'supplier-account'|null;
  stockMovements: InventoryMovementProjection[];
  businessTab: 'overview'|'expenses'|'cash'|'staff'|'tasks';
  businessDrawer: 'expense'|'expense-cancel'|'supplier-pay'|'shift'|'task'|null;
  selectedExpenseId: string | null; selectedPurchaseId: string | null; selectedShiftId: string | null; selectedTaskId: string | null; selectedStaffId: string | null;
  employeesTab: 'list'|'calendar'|'salary';
  employeeDrawer: 'detail'|'leave'|'adjustment'|null;
  employeeFilter: 'all'|'working'|'on_leave'|'off_shift'|'passive';
  employeeQuery: string; selectedLeaveId: string | null; leaveDate: string | null; calendarMonth: string | null; calendarStaffId: string; salaryMonth: string | null; salaryStaffId: string;
}

export const viewTitles: Record<ViewKey, { kicker: string; title: string }> = {
  dashboard: { kicker: 'GENEL BAKIŞ', title: 'Dashboard' },
  appointments: { kicker: 'RANDEVU TAKVİMİ', title: 'Randevular' },
  clients: { kicker: 'MÜŞTERİ YÖNETİMİ', title: 'Müşteriler' },
  catalog: { kicker: 'DİJİTAL STİL MENÜSÜ', title: 'Stil Kataloğu' },
  inventory: { kicker: 'STOK & TEDARİK', title: 'Stok & Ürünler' },
  checkout: { kicker: 'SATIŞ & ÖDEME', title: 'Satış / Ödeme' },
  business: { kicker: 'İŞLETME YÖNETİMİ', title: 'İşletme' },
  employees: { kicker: 'PERSONEL YÖNETİMİ', title: 'Çalışanlar' },
  operations: { kicker: 'GÜNLÜK OPERASYON', title: 'Operasyon' },
  reports: { kicker: 'ÖZET RAPORLAR', title: 'Raporlar' },
  settings: { kicker: 'SALON AYARLARI', title: 'Ayarlar' }
};
